import * as React from "react";
import { useGetCountriesQuery } from "../services/country.service";
import SelectBase, { SelectOption } from "./global/SelectBase";

const SelectCountry = ({
  onChange,
  value,
}: {
  onChange: (arg?: number) => void;
  value: number;
}) => {
  const {
    data: countries,
    isLoading,
  } = useGetCountriesQuery({
    sortField: "name",
    sortMode: "asc",
  });

  const options = React.useMemo<SelectOption[]>(() => {
    return (countries || []).map((country) => ({
      label: country.name,
      value: country.id,
    }));
  }, [countries]);

  const selected = React.useMemo<SelectOption | null>(() => {
    if (!value || !countries) return null;
    const country = countries.find((it) => it.id == value);
    return country ? { label: country.name, value: country.id } : null;
  }, [countries, value]);

  return (
    <SelectBase
      options={options}
      value={selected}
      onChange={(newValue) => {
        const option = newValue as SelectOption | null;
        onChange(option?.value as number | undefined);
      }}
      label="Country"
      placeholder="Search..."
      isLoading={isLoading}
    />
  );
};
export default SelectCountry;
